import styles from './MainPage.module.scss';
import clsx from 'clsx';
import Typed from 'typed.js';
import React, { useState, useEffect, useRef, useMemo } from 'react';

const MainPage = (props) => {
  
  const el = useRef(null);
  const typed = useRef(null);

  useEffect(() => {
    let options;
    if (props.language === 'pl') {
      options = {
        strings: [
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',
          'Strony internetowe',
          'Aplikacje webowe',
          'Cybersecurity',

          // ... Other lines with Polish texts
          'Strony internetowe', // This line is duplicated, you can add more Polish texts here
        ],
        typeSpeed: 50,
        backSpeed: 50,
      };
    } else if (props.language === 'eng') {
      options = {
        strings: [
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',
          'Websites',
          'Web Applications',
          'Cybersecurity',

          // ... Other lines with English texts
          'Websites', // This line is duplicated, you can add more English texts here
        ],
        typeSpeed: 50,
        backSpeed: 50,
      };
    }

    typed.current = new Typed(el.current, options);

    return () => {
      typed.current.destroy();
    };
  }, [props.language]);

  useEffect(() => {
    const handleResize = () => {
      // Tutaj możesz umieścić kod, który będzie wykonywany podczas zmiany rozmiaru okna
      // na przykład, odświeżanie widoku, ponowne obliczenie stylów, itp.
      // console.log('Okno zostało zmienione!');
    };

    // Dodajemy nasłuchiwanie na zdarzenie resize okna
    window.addEventListener('resize', handleResize);

    // Zwracamy funkcję czyszczącą, która usunie nasłuchiwanie po zniszczeniu komponentu
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <div>
      <div className={styles.wrapper}>
        <div className={clsx(styles.cols, styles.cols0)}><div className={styles.gapDiv}></div>
          <div className={styles.innerDiv}>
            <img className={styles.logo} alt="CometwebLogo" src={`${process.env.PUBLIC_URL}/Cometweb/1transparent.png`}></img>
          </div>
            {props.language === 'pl' &&
              <h1 className={styles.title}>Czym się zajmujemy? </h1>
            }
            {props.language === 'eng' &&
              <h1 className={styles.title}>What do we do? </h1>
            }
            <h1 className={styles.multiText}>
            <span className={styles.multiText}>
              <span style={{ whiteSpace: 'pre' }} ref={el} />
            </span></h1>
            {props.language === 'pl' &&
              <p className={styles.p}>
                Łączymy doświadczenie, kreatywność i innowacyjność, aby zapewnić Państwu rozwiązania spełniające potrzeby. 
                Jesteśmy specjalistami z wieloletnim doświadczeniem w tworzeniu oprogramowania. Zapewniamy kompletny zespół, który zajmie się stworzeniem oprogramowania, 
                od określenia wymagań po wspieranie gotowego rozwiązania.
                Każdy projekt jest dla nas unikalny i traktujemy go z indywidualnym podejściem, 
                tak aby zapewnić Państwu nie tylko świetnie wyglądającą stronę i niezawodną aplikację, 
                ale również najefektywniej rozpromować ją w sieci.
              </p>
            }
            {props.language === 'eng' &&
              <p className={styles.p}>
                We combine experience, creativity and innovation to provide you with solutions that meet your needs. 
                We are specialists with years of experience in software development. We provide a complete team to take care of software development, 
                from defining the requirements to supporting the finished solution.
                Each project is unique to us and we treat it with an individual approach, 
                so as to provide you not only with a great-looking website and a reliable application, 
                but also to promote it most effectively on the web.
              </p>
            }
            <div className={styles.btns}>
              {props.language === 'pl' &&
                <button className={styles.button} onClick={() => props.scrollToSection('sesja1')}>Sprawdź naszą ofertę</button>
              }
              {props.language === 'eng' &&
                <button className={styles.button} onClick={() => props.scrollToSection('sesja1')}>Check out our offer</button>
              }
            </div>
        </div>
      </div>
    </div>
  );
};

export default MainPage;